<template>
  <div class="container">
    <div class="row">
      <div class="col-right-padding col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <h1 class="title pb-lg-4 mb-5">{{ pageTitle }}</h1>
        <div v-if="registerErrorMsg">
          <ErrorMessage class="mb-4 mb-lg-5" :errorNotification="errorNotification" />
        </div>
        <div v-if="!registerErrorMsg && errorMsg != '' && errorMsg != undefined && errorMsg != null">
          <ErrorMessage class="mb-4 mb-lg-5" :errorNotification="errorMsg" />
        </div>

        <label class="label mb-1">Title</label>
        <div class="select-box row col-6 p-0 m-0 position-relative">
         <select class="form-control pl-4" v-model.trim.lazy="title" @blur="v$.title.$touch()"
           v-bind:class="{ 'error-box': v$.title.$dirty && v$.title.$invalid }">
           <optgroup>
             <option value="" disabled selected>Select</option>
             <option value="Dr">Dr.</option>
             <option value="Miss">Miss.</option>
             <option value="Mr">Mr.</option>
             <option value="Mrs">Mrs.</option>
             <option value="Ms">Ms.</option>
             <option value="Other">Other</option>
           </optgroup>
         </select>
         <span data-test="select-icon" class="select-icon position-absolute" style="right: 0px; top: 0%; transform: translateY(-40%); pointer-events: none;">
           <img src="@/assets/chevron-down.svg" class="arrow-icon" alt="Dropdown Icon" />
         </span>
        </div>
          <div class="error-text mt-1" v-if="v$.title.$dirty">
            <p v-if="v$.title.$invalid">Please select a title.</p>
          </div>
        

        <label class="label pt-3 pt-lg-0 mt-3 mt-lg-5">First Name</label>
        <input
          class="form-control input-field pl-4"
          type="text"
          v-model.trim.lazy="firstName" @input="v$.firstName.$touch()" @blur="v$.firstName.$touch()"
          v-bind:class="{ 'error-box': v$.firstName.$dirty && v$.firstName.$invalid }"
        />
        <div class="error-text mt-1" v-if="v$.firstName.$dirty">
          <p
            v-if="v$.firstName.$dirty && v$.firstName.$invalid">
            Please enter a valid first name.</p>
        </div>

        <label class="label pt-3 pt-lg-0 mt-3 mt-lg-5">Last Name</label>
        <input class="form-control input-field pl-4" type="text" v-model.trim.lazy="lastName" @input="v$.lastName.$touch()" @blur="v$.lastName.$touch()"
          v-bind:class="{ 'error-box': v$.lastName.$dirty && v$.lastName.$invalid }">
        <div class="error-text mt-1" v-if="v$.lastName.$dirty">
          <p v-if="v$.lastName.$dirty && v$.lastName.$invalid">
            Please enter a valid last name.</p>
        </div>

        <label class="label pt-3 pt-lg-0 mt-3 mt-lg-5">Email Address</label>
        <input class="form-control input-field pl-4" type="email" v-model.trim.lazy="email" @input="v$.email.$touch()" @blur="v$.email.$touch()"
          v-bind:class="{ 'error-box': v$.email.$dirty && v$.email.$invalid }">
        <div class="error-text mt-1" v-if="v$.email.$dirty">
          <p v-if="v$.email.$dirty && (v$.email.$invalid || !v$.email.email)">Please enter a valid email address.</p>
        </div>
        <div>
          <label class="label pt-3 pt-lg-0 mt-3 mt-lg-5 float-left">Password</label>
          <label
            v-if="showPasswordToggle && showPasswordLink"
            class="label pt-3 pt-lg-0 mt-3 mt-lg-5 float-right password-show-hide"
            @click="showPassword('text')">Show Password</label>
          <label v-if="showPasswordToggle && hidePasswordLink"
            class="label pt-3 pt-lg-0 mt-3 mt-lg-5 float-right password-show-hide"
            @click="showPassword('password')">Hide Password</label>
        </div>
        <input class="form-control input-field pl-4" :type="passwordInputType" v-model="password"
          @blur="showPasswordValidation = true" @input="showPasswordValidation = true; v$.password.$touch()"
          @focus="onPasswordFocus"
          maxlength="255"
          v-bind:class="{ 'error-box': showPasswordValidation && v$.password.$dirty && v$.password.$invalid }">
        <div class="mt-1"
          v-if="showPasswordCriteria || (v$.password.$dirty && showPasswordValidation && (v$.password.required.$invalid || v$.password.minLength.$invalid || v$.password.containsUpperCase.$invalid || v$.password.containsNumberOrSpecialChar.$invalid))">
          <p class="password-error-text"
            v-if="v$.password.$dirty && showPasswordValidation && (v$.password.required.$invalid || v$.password.minLength.$invalid || v$.password.containsUpperCase.$invalid || v$.password.containsNumberOrSpecialChar.$invalid)">
            Please enter a password containing:</p>
          <ul class="password-criteria">
            <li class="d-flex"
              v-bind:class="{ 'error': showPasswordValidation && v$.password.$dirty && v$.password.minLength.$invalid }"><img
                class="float-left"
                :src="getPasswordCriteriaIcon(v$.password.$dirty, !v$.password.minLength.$invalid && !v$.password.required.$invalid)" /><span
                class="float-left"
                v-bind:class="{ 'error-text': showPasswordValidation && v$.password.$dirty && (v$.password.minLength.$invalid || v$.password.required.$invalid) }">At
                least 10 characters</span></li>
            <li class="d-flex"
              v-bind:class="{ 'error': showPasswordValidation && v$.password.$dirty && !v$.password.containsUpperCase.$invalid }">
              <img class="float-left"
                :src="getPasswordCriteriaIcon(v$.password.$dirty, !v$.password.containsUpperCase.$invalid)" /><span
                class="float-left"
                v-bind:class="{ 'error-text': showPasswordValidation && v$.password.$dirty && v$.password.containsUpperCase.$invalid }">An
                uppercase letter</span>
            </li>
            <li class="d-flex"
              v-bind:class="{ 'error': showPasswordValidation && v$.password.$dirty && !v$.password.containsNumberOrSpecialChar }">
              <img class="float-left"
                :src="getPasswordCriteriaIcon(v$.password.$dirty, !v$.password.containsNumberOrSpecialChar.$invalid)" /><span
                class="float-left"
                v-bind:class="{ 'error-text': showPasswordValidation && v$.password.$dirty && v$.password.containsNumberOrSpecialChar.$invalid }">A
                number or special character (!@£%^)</span>
            </li>
          </ul>
        </div>

        <label class="label pt-3 pt-lg-0 mt-3 mt-lg-5">Confirm Password</label>
        <input class="form-control input-field pl-4" type="password" v-model.lazy="confirmPassword" @blur="v$.confirmPassword.$touch()"
          v-bind:class="{ 'error-box': v$.confirmPassword.$dirty && v$.confirmPassword.$invalid }" maxlength="255">
        <div class="error-text mt-1" v-if="v$.confirmPassword.$dirty">
          <p v-if="v$.confirmPassword.$invalid">Your passwords don't match</p>
        </div>

        <h2 class="header pb-3 pt-lg-3 mb-3 mt-5">DO YOU HAVE AN EXISTING REWARDS CARD?</h2>

        <input type="radio" id="no" :value="no" class="input-btn mt-2 mr-3" v-model="doesUserHaveRewards">
        <p class="text clickable pb-3 mb-3" @click="noRewardsCard">No, I need to join Harrods Rewards</p>
        <input type="radio" id="yes" :value="yes" class="input-btn mt-2 mr-3" v-model="doesUserHaveRewards">
        <p class="text clickable pb-2 mb-3" @click="yesRewardsCard">Yes, I already have a Rewards card</p>

        <Transition name="collapse">
            <div v-show="enterRewardsCard">
                <label class="label mb-1">Harrods Rewards card number</label>
                <input class="form-control input-field mb-3 pl-4" maxlength="16" type="text" v-model.trim.trim.lazy="rewardsNumber" @input="rewardsNumber = rewardsNumber.replace(/\D/g, ''); v$.rewardsNumber.$touch()" @blur="v$.rewardsNumber.$touch()"
                       v-bind:class="{ 'error-box': v$.rewardsNumber.$dirty && v$.rewardsNumber.$invalid }"
                       placeholder="Enter your 16 digit Rewards card number">
                <div class="error-text" v-if="v$.rewardsNumber.$dirty">
                    <p class="mt-1 mb-3 mb-lg-4" v-if="v$.rewardsNumber.$invalid">
                        Rewards number must be a 16 digit number
                    </p>
                </div>

                <router-link :to="`/en-gb${isMyBeauty ? '/mybeauty' : ''}/retrieve-card-number`" target="_blank">
                    <p class="hyperlink mb-5">Don’t know your card number?</p>
                </router-link>
                </div></Transition>

                <div v-if="showPromoCodeField">
                    <label class="label pt-3 pt-lg-0 mt-3 mt-lg-5">Promotional Code</label>
                    <input class="form-control input-field pl-4" type="text" v-model.trim.lazy="promoCode"
                           v-bind:class="{ 'error-box': v$.promoCode.$dirty && !v$.promoCode.alphaNum }">
                    <div class="error-text" v-if="v$.promoCode.$dirty && !v$.promoCode.alphaNum">
                        <p class="mt-1 mb-3 mb-lg-4" v-if="!v$.promoCode.alphaNum">Please enter a valid promotional code.</p>
                    </div>
                </div>
                <div class="gold-notification mt-5">
                    <h2 v-if="!isMyBeauty" class="header mb-3">COMMUNICATION</h2>
                    <h2 v-else class="header mb-3">FROM TIME TO TIME, WE'D LIKE TO SEND YOU EMAILS ABOUT:</h2>

                    <div class="custom-text-communication">
                        <p v-if="!isMyBeauty" class="text mb-3">
                            Please tick below to receive updates about Harrods products, services
                            and promotions, as well as your Harrods Rewards <span v-if="isMyBeauty">and MyBeauty</span> membership<span v-if="isMyBeauty">s</span>. This includes membership benefits, your progress to unlock the next <span v-if="isMyBeauty">beauty </span>rewards, and special offers.
                        </p>
                        <p v-else class="text mb-3">
                            <ul class="comms-list">
                                <li class="comms-list-item">Updates on your MyBeauty and Harrods Rewards membership</li>
                                <li class="comms-list-item">Offers and promotions</li>
                                <li class="comms-list-item">The latest Harrods and H beauty news</li>
                                <li class="comms-list-item">Exciting beauty launches</li>
                                <li class="comms-list-item">Exclusive event invitations</li>
                            </ul>
                        </p>
                    </div>

                    <input type="checkbox" class="input-btn mt-2 mr-3" v-model="marketingOptIn">
                    <p class="text">Yes please! Contact me by email</p>
                </div>
                <div class="custom-text-communication pb-lg-4 mb-5 mt-5">
                    <p v-if="doesUserHaveRewards === no" class="text" style="line-height: 24px;">
                        For a more bespoke shopping experience, we may
                        collect additional relevant data about you (which you have made available via third parties). Please contact
                        Customer Services if you wish to opt-out of this.
                    </p>
                </div>

                <button v-if="!isMyBeauty" @click="register" type="submit" class="btn btn-primary green-btn">
                    <span v-if="showLoader" label="Spinning" class="spinner-border spinner-border-sm white-spinner" role="status" aria-hidden="true"></span>
                    <div v-if="!showLoader">Complete Registration</div>
                </button>

                <button v-else @click="register" type="submit" class="btn btn-primary green-btn">
                    <span v-if="showLoader" label="Spinning" class="spinner-border spinner-border-sm white-spinner" role="status" aria-hidden="true"></span>
                    <div v-if="!showLoader">Join Harrods Rewards & MyBeauty</div>
                </button>

                <AgreementUnsubscription class="custom-text-agreement-and-unsubscription" />
            </div>
            <div class="col-4 d-none d-sm-none d-md-none d-lg-block d-xl-block">
                <div class="notification">
                    <RewardsCardImg class="mb-5" />

                    <h3 class="mb-2 pb-3">HOW HARRODS REWARDS WORKS</h3>

                    <img class="icon mt-1 mb-5 mr-3" src="@/assets/card.svg">
                    <p class="text mb-2 pb-3">
                        Use your Rewards card every time you shop online, in-store or at our airport
                        boutiques.
                    </p>
                    <img class="icon mt-1 mb-5 mr-3" src="@/assets/rewards-card.svg">
                    <p class="text mb-2 pb-3">
                        You will earn points for every £1 you spend at Harrods, no matter how you choose to
                        pay.
                    </p>
                    <img class="icon mt-1 mb-5 mr-3" src="@/assets/financial.svg">
                    <p class="text mb-5">
                        For every 500 points collected you’ll receive £5 which will be uploaded onto your Rewards
                        card.
                    </p>

                    <h3 class="mb-2 pb-3">SEE HOW YOUR BENEFITS BUILD</h3>

                    <img class="icon mt-1 mr-3" src="@/assets/checkmark.svg">
                    <p class="text mb-2">Access exclusive discount days</p>
                    <img class="icon mt-1 mr-3" src="@/assets/checkmark.svg">
                    <p class="text mb-2">Earn Rewards points on purchases</p>
                    <img class="icon mt-1 mr-3" src="@/assets/checkmark.svg">
                    <p class="text pb-3 mb-3">Spend Rewards points in-store</p>
                </div>
            </div>
</div>
  </div>
</template>

<script setup>
    defineOptions({ name: 'RegisterForm' })
    import { ref, computed, watch, onMounted, inject } from 'vue'
    import useVuelidate from '@vuelidate/core'
    import { required, email as emailValidator, sameAs, minLength, maxLength, alphaNum } from '@vuelidate/validators'
    import RewardsCardImg from '@/components/RewardsCardImg.vue'
    import ErrorMessage from '@/components/ErrorMessage.vue'
    import AgreementUnsubscription from '@/components/AgreementUnsubscription.vue'
    import integrationApi from '@/services/IntegrationApiClient.js'
    import { useRouter, useRoute } from 'vue-router'
    import { useStore } from 'vuex'

    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const isMyBeauty = inject('isMyBeauty', computed(() =>
        route.params.isMyBeauty === 'mybeauty' ||
        route.query.isMyBeauty === 'true' ||
        route.query.isMyBeauty === true
    ))

    // Custom validators
    const lettersOnly = value => /^[-‘a-zA-ZÀ-ž'\s]*$/.test(value)
    const latinOnly = value => /^[\u0000-\u024F]+$/.test(value)
    const noPlusSymbol = value => !/\+/.test(value)
    const containsUpperCase = value => /[\p{Lu}]/u.test(value)
    const containsNumberOrSpecialChar = value => /[\d\p{P}\p{S}]/u.test(value) && latinOnly(value)

    // Props
    const props = defineProps([
        'pageTitle',
        'source',
        'passUserRewardsAnswer',
        'errorMsg',
        'prefillEmail',
        'prefillMarketingOptIn'
    ])

    // Form fields and UI state
    const title = ref('')
    const firstName = ref('')
    const lastName = ref('')
    const email = ref(props.prefillEmail || '')
    const password = ref('')
    const confirmPassword = ref('')
    const promoCode = ref('')
    const rewardsNumber = ref('')
    const doesUserHaveRewards = ref(props.passUserRewardsAnswer === true ? 'yes' : 'no')
    const yes = 'yes'
    const no = 'no'
    const showLoader = ref(false)
    const marketingOptIn = ref(props.prefillMarketingOptIn === true)
    const showPasswordCriteria = ref(false)
    const showPasswordLink = ref(false)
    const hidePasswordLink = ref(false)
    const showPasswordToggle = ref(false)
    const passwordInputType = ref('password')
    const showPasswordValidation = ref(false)
    const errorNotification = ref('')
    const registerErrorMsg = ref(false)

    // Validation rules
    const rules = computed(() => ({
        title: { required },
        firstName: { required, lettersOnly, minLength: minLength(2), maxLength: maxLength(64) },
        lastName: { required, lettersOnly, minLength: minLength(2), maxLength: maxLength(64) },
        email: { required, latinOnly, email: emailValidator, noPlusSymbol },
        password: { required, minLength: minLength(10), containsUpperCase, containsNumberOrSpecialChar },
        confirmPassword: { sameAsPassword: sameAs(password) },
        rewardsNumber: { sixteenDigits: value => value === '' || value.length === 16 },
        promoCode: { alphaNum }
    }))
    watch(() => email.value, (newValue) => {
        console.log('Email:', newValue);
        watch(() => email.value, (newValue) => {
            console.log('Email:', newValue);
            console.log('Validation State:', v$.value.email); // Updated to v$.value.email  
        });
    });
    const v$ = useVuelidate(rules, {
        title,
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        promoCode,
        rewardsNumber
    })

    // Lifecycle: initialize form fields from props and query
    onMounted(() => {
        if (showPromoCodeField.value && typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search)
            promoCode.value = urlParams.get('promo_code') || ''
        }
        email.value = props.prefillEmail || ''
        marketingOptIn.value = props.prefillMarketingOptIn === true
        decryptPurplePayload()
    })

    // Watch for prop changes
    watch(() => props.prefillEmail, val => { email.value = val })
    watch(() => props.prefillMarketingOptIn, val => { marketingOptIn.value = val })

    // Computed
    const showPromoCodeField = computed(() => {
        if (typeof window === 'undefined') return false
        return window.location.pathname.toLowerCase().includes('events-register')
    })
    const enterRewardsCard = computed({
        get: () => doesUserHaveRewards.value === "yes",
        set: val => { doesUserHaveRewards.value = val ? "yes" : "no" }
    })

    // Methods
    async function register() {
        showLoader.value = true;
        showPasswordValidation.value = true;
        v$.value.$touch();
        if (v$.value.$invalid) {
            registerErrorMsg.value = true
            errorNotification.value = 'Please enter valid user details'
            showLoader.value = false;
            window.scrollTo(0, 0);
        } else if (doesUserHaveRewards.value === yes && rewardsNumber.value === '') {
            registerErrorMsg.value = true
            errorNotification.value = 'Please provide a rewards card number'
            showLoader.value = false;
            window.scrollTo(0, 0);
        } else if (!v$.value.$invalid) {
            processSignUpTracking();
            showLoader.value = false;

            // Build the newUser object
            const newUser = {
                title: title.value,
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                password: password.value,
                marketingOptIn: marketingOptIn.value,
                rewardsNumber: rewardsNumber.value,
                doesUserHaveRewards: doesUserHaveRewards.value == 'no' ? 0 : 1,
                source: props.source ?? 'CN',
                promoCode: promoCode.value,
                joinBeautyClub: isMyBeauty
            }

            // Commit to Vuex
            store.commit('register/setNewUser', newUser);

            // route to CreatingAccount view
            router.push({ name: 'CreatingAccount' });

        } else {
            registerErrorMsg.value = true
            errorNotification.value = 'Please fill in the registration form'
            showLoader.value = false;
            window.scrollTo(0, 0);
        }
    }

    function processSignUpTracking() {
        if (typeof window !== 'undefined' && window.$gtm) {
            window.$gtm.trackEvent({
                event: 'sign_up_start',
                method: isMyBeauty.value ? 'MyBeauty' : 'Rewards'
            })
        }
    }

    function noRewardsCard() {
        doesUserHaveRewards.value = no
    }
    function yesRewardsCard() {
        doesUserHaveRewards.value = yes
    }
    function decryptPurplePayload() {
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search)
            const u = urlParams.get('u')
            if (u) {
                integrationApi.decryptVal(u).then(result => {
                    email.value = result.email
                    marketingOptIn.value = result.optedIn === true
                })
            }
        }
    }
    function getPasswordCriteriaIcon(isDirty, isValid) {
        if (!isDirty) {
            return require('@/assets/oval.svg')
        } else if (isValid) {
            return require('@/assets/icon-general-checkmark.svg')
        } else if (!showPasswordValidation.value) {
            console.log('here2');
            return require('@/assets/oval.svg')
        }
        return require('@/assets/icon-general-close.svg')
    }
    function showPassword(type) {
        passwordInputType.value = type
        hidePasswordLink.value = type === 'text'
        showPasswordLink.value = type === 'password'
    }
    function onPasswordFocus() {
        showPasswordCriteria.value = true
        if (!showPasswordToggle.value) showPasswordLink.value = true
        showPasswordToggle.value = true
    }
</script>

<style lang="scss" scoped>
.gold-notification {
  color: #424242;
  font-size: 16px;
  background-color: rgba(171, 142, 102, 0.05);
  border: solid 1px #ab8e66;
  border-radius: 0px;
  padding: 15px;

  .header {
    letter-spacing: 1.5px;
  }
}

.password-show-hide {
  color: #967c59;
  cursor: pointer;
}

.password-criteria {
  margin: 10px 0px 10px 0;
  font-family: "Founders Grotesk";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #424242;

  img {
    margin-right: 9px;
  }
}

.password-error-text {
  font-family: "Founders Grotesk";
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: 0.4px;
  color: #eb001c;
}

.custom-text-communication p {
  @media screen and (min-width: 768px) {
    font-size: 15px;
  }
}

.custom-text-agreement-and-unsubscription p {
  font-size: 14px;
  font-weight: normal;
}

.container {
  background-color: $harrods-white;

  @media screen and (max-width: 1199px) and (min-width: 992px) {
    padding-right: 50px;
    padding-left: 50px;
  }

  @media screen and (min-width: 1200px) {
    padding-right: 75px;
    padding-left: 75px;
  }
}

.col-right-padding {

  @media screen and (max-width: 1199px) and (min-width: 992px) {
    padding-right: 148px;
  }

  @media screen and (min-width: 1200px) {
    padding-right: 105px;
  }
}

.input-btn {
  float: left;

  &:hover,
  :active,
  :focus {
    cursor: pointer;
  }
}

.clickable {

  &:hover,
  :active,
  :focus {
    cursor: pointer;
  }
}

.notification {
  height: 802px;
  padding: 30px 30px 50px 30px;

  @media screen and (max-width: 1199px) and (min-width: 992px) {
    width: 302px;
  }

  @media screen and (min-width: 1200px) {
    width: 320px;
    margin-left: 40px;
  }
}

h3 {
  color: $dark-grey-1;
  font-family: "Miller Banner";
  font-size: 24px;
  font-weight: 300;
}

.header {
  letter-spacing: 1.5px;
}

.comms-list {

  margin-left: 15px;
}

.comms-list-item {
  list-style: none;
  line-height: 24px;
  display: flex;
}

.comms-list-item:before {
  content: "•";
  padding-right: 20px;
}
</style>
